(() => {
  const normalize = (value) => String(value || '')
    .toLowerCase()
    .trim()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

  const tokenContains = (tokens, part) => {
    if (tokens.includes(part)) return true;
    return part.endsWith('s') && tokens.includes(part.slice(0, -1));
  };

  const matchesFilter = (card, rawFilter) => {
    const filter = normalize(rawFilter);
    const tokens = normalize(card.dataset.filterTokens);

    if (!filter || filter === 'all') return true;
    if (filter.includes('bundle') || filter.includes('value-pack')) {
      return /bundle|pack|buy-[0-9]+|[0-9]+-x|best-value|(^|-)save(-|$)/.test(tokens);
    }
    if (filter.includes('groom')) return /groom|shampoo|conditioner/.test(tokens);
    if (filter.includes('meal-topper') || filter === 'topper' || filter === 'toppers') return tokens.includes('topper');

    return filter
      .split('-')
      .filter((part) => part && part !== 'and')
      .every((part) => tokenContains(tokens, part));
  };

  const initCollection = (root) => {
    if (!root || root.dataset.hpCollectionReady === 'true') return;
    root.dataset.hpCollectionReady = 'true';

    const cards = [...root.querySelectorAll('[data-hp-collection-card]')];
    const chips = [...root.querySelectorAll('[data-hp-collection-chip]')];
    const chipBar = root.querySelector('[data-hp-chip-bar]');
    const count = root.querySelector('[data-hp-product-count]');
    const helper = root.querySelector('[data-hp-helper-strip]');
    const sort = root.querySelector('[data-hp-sort]');

    if (chipBar && chips.length > 1) {
      let matchingCustomChips = 0;

      chips.forEach((chip) => {
        if (chip.dataset.filter === 'all') return;
        const matchCount = cards.filter((card) => matchesFilter(card, chip.dataset.filter)).length;
        chip.hidden = matchCount === 0;
        chip.setAttribute('aria-hidden', String(matchCount === 0));
        if (matchCount > 0) matchingCustomChips += 1;
      });

      if (matchingCustomChips === 0) chipBar.hidden = true;
    }

    chips.forEach((chip) => {
      if (chip.hidden) return;

      chip.addEventListener('click', () => {
        const filter = chip.dataset.filter;
        let visible = 0;

        chips.forEach((item) => item.setAttribute('aria-pressed', String(item === chip)));
        cards.forEach((card) => {
          const show = matchesFilter(card, filter);
          card.hidden = !show;
          card.setAttribute('aria-hidden', String(!show));
          if (show) visible += 1;
        });

        if (helper) helper.hidden = normalize(filter) !== 'all';
        if (count) count.textContent = `${visible} ${visible === 1 ? 'product' : 'products'}`;
      });
    });

    if (sort) {
      sort.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    }

    root.querySelectorAll('.hp-collection__faq details').forEach((details) => {
      const summary = details.querySelector('summary');
      if (!summary) return;
      summary.setAttribute('aria-expanded', String(details.open));
      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(details.open));
      });
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-hp-collection]').forEach(initCollection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
